







































import { gmapApi } from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'

enum GmapStatus {
  OK = 'OK',
  NotFound = 'NOT_FOUND',
  ZeroResults = 'ZERO_RESULTS',
  MaxWaypointsExceeded = 'MAX_WAYPOINTS_EXCEEDED',
  MaxRouteLengthExceeded = 'MAX_ROUTE_LENGTH_EXCEEDED',
  InvalidRequest = 'INVALID_REQUEST',
  OverDailyLimit = 'OVER_DAILY_LIMIT',
  OverQueryLimit = 'OVER_QUERY_LIMIT',
  RequestDenied = 'REQUEST_DENIED',
  Unknown = 'UNKNOWN_ERROR'
}

export default {
  components: { GmapCustomMarker },
  props: {
    origin: { type: Object, required: true },
    destination: { type: Object, required: true },
    waypoints: {
      type: Array,
      required: false,
      default: () => []
    },
    stopLocations: { type: Array, default: () => [] },
    multiStopsLimitReached: { type: Boolean, default: false }
  },
  data: () => ({
    isMapInitialized: false,
    infoWindow: {
      position: { lat: 0, lng: 0 },
      open: false,
      template: ''
    }
  }),
  computed: {
    google: gmapApi,
    center() {
      return {
        lat: (+this.origin.latitude + +this.destination.latitude) / 2,
        lng: (+this.origin.longitude + +this.destination.longitude) / 2
      }
    }
  },
  async mounted() {
    await this.$gmapApiPromiseLazy()
    if (this._isBeingDestroyed) {
      return
    }

    await this.$refs.mymap.$mapPromise
    const directionsService = new this.google.maps.DirectionsService()
    const directionsDisplay = new this.google.maps.DirectionsRenderer()
    directionsDisplay.setMap(this.$refs.mymap.$mapObject)
    directionsDisplay.setOptions({ suppressMarkers: true })
    directionsService.route(
      {
        origin: this.createCoordinatesForMap(this.origin),
        destination: this.createCoordinatesForMap(this.destination),
        waypoints: this.createWaypointsCoordinates(this.waypoints),
        travelMode: 'DRIVING'
      },
      (route, status) => {
        if (status !== GmapStatus.OK) {
          this.$emit('routeNotAvailable', true)
          return
        }

        directionsDisplay.setDirections(route)
        this.mapInitialized = true
      }
    )
  },
  methods: {
    createCoordinatesForMap(address) {
      return new this.google.maps.LatLng(address.latitude, address.longitude)
    },
    createWaypointsCoordinates(waypoints) {
      return waypoints.map(waypoint => ({
        location: new this.google.maps.LatLng(
          waypoint.location.latitude,
          waypoint.location.longitude
        ),
        stopover: true
      }))
    },
    showInfoWindow(args) {
      this.infoWindow = {
        position: { lat: +args.lat, lng: +args.lng },
        open: true,
        template: args.address
      }
    },
    getLabel(index) {
      return String.fromCharCode(parseInt(index) + 65)
    },
    setZoomForFallbackLocation() {
      return this.multiStopsLimitReached ? 6 : null
    }
  }
}
